/* eslint-disable import/no-cycle */
import Keyboard from './Keyboard';
import TextArea from './TextArea';
import { activeKey, pressShift } from './utils';

export default class Button {
  constructor(props) {
    this.funcInput = props;
  }

  createButtons(mode, target) {
    this.keyboard = document.querySelector('.keyboard');
    this.keyboard.innerHTML = '';
    mode.forEach((element) => {
      const keyboardKeyCreate = document.createElement('button');
      keyboardKeyCreate.innerText = `${element}`;
      if (element === target) {
        keyboardKeyCreate.classList.add('keyboard-key');
        keyboardKeyCreate.classList.add('keyboard-key__wide');
        keyboardKeyCreate.classList.add('keyboard-key__active');
      } else if (element.length > 3) {
        keyboardKeyCreate.classList.add('keyboard-key');
        keyboardKeyCreate.classList.add('keyboard-key__wide');
      } else if (element === ' ') {
        keyboardKeyCreate.classList.add('keyboard-key');
        keyboardKeyCreate.classList.add('keyboard-key__extra-wide');
      } else {
        keyboardKeyCreate.classList.add('keyboard-key');
      }
      this.keyboard.append(keyboardKeyCreate);
    });
    const key = new Keyboard(this.funcInput);
    key.mouseEvent();
  }

  keyEvent() {
    let keyboardKey = document.querySelectorAll('.keyboard-key');
    document.addEventListener('keydown', (el) => {
      el.preventDefault();
      keyboardKey = document.querySelectorAll('.keyboard-key');
      const area = new TextArea(this.funcInput);
      if (el.key.length === 1) {
        area.inputKey(el.key);
      }
      switch (el.key) {
        case 'Backspace':
          area.inputKey(el.key);
          break;
        case 'Delete':
          area.inputKey('Del');
          break;
        case 'Tab':
          area.inputKey(el.key);
          break;
        case 'Enter':
          area.inputKey(el.key);
          break;
        case 'Shift':
          pressShift('Shift', this.funcInput);
          break;
        case 'ArrowLeft':
          area.changeCursorPosition(el.key);
          break;
        case 'ArrowRight':
          area.changeCursorPosition(el.key);
          break;

        default:
          break;
      }
      activeKey(keyboardKey, el);
    });
    document.addEventListener('keyup', (el) => {
      keyboardKey.forEach((vir) => {
        if (vir.classList.contains('keyboard-key__active')) {
          vir.classList.remove('keyboard-key__active');
        }
      });
      if (el.key === 'Shift') {
        pressShift('', this.funcInput);
      } else if (el.key === 'CapsLock') {
        pressShift('', this.funcInput);
        keyboardKey = document.querySelectorAll('.keyboard-key');
      }
    });
  }
}
